<template>
	<div class="header">
		<div>
			<div class="link" @click="setCollapse(!isCollapse)">
				<i
					:class="{
						'el-icon-s-unfold': isCollapse,
						'el-icon-s-fold': !isCollapse
					}"
				></i>
			</div>
			<Breadcrumb />
		</div>
		<div>
			<!-- <el-tooltip class="link" style="height:60px" effect="dark" content="换肤" placement="bottom">
        <el-switch active-color="#0a0a0a" inactive-color="#409EFF" v-model="value">
        </el-switch>
      </el-tooltip> -->
			<span class="lang">
				<!-- <lang-select class="set-language" /> -->
			</span>
			<div class="link" @click="lock">
				<i class="el-icon-lock"></i>
			</div>

			<Screenfull class="link" />

			<el-dropdown class="dropdown link" trigger="click" @command="handleCommand">
				<el-tooltip class="item" effect="dark" :content="userInfo.remark" placement="bottom">
					<span> Hello~, {{ userInfo.username }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
				</el-tooltip>

				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="c" divided>{{ langTxt('退出登录') }}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import Breadcrumb from './Breadcrumb';
	import Screenfull from './Screenfull';

	export default {
		components: {
			Breadcrumb,
			Screenfull
		},
		data() {
			return {
				value: false
			};
		},
		computed: {
			isCollapse() {
				return this.$store.state.layout.isCollapse;
			},
			userInfo() {
				if (sessionStorage.getItem('admin-info')) {
					return JSON.parse(sessionStorage.getItem('admin-info'));
				} else {
					return {
						username: 'admin'
					};
				}
			}
		},

		methods: {
			// 控制侧边栏导航
			setCollapse(collapse) {
				this.$store.commit('setCollapse', collapse);
			},
			toggleClass(element, className) {
				if (!element || !className) {
					return;
				}
				let classString = element.className;
				const nameIndex = classString.indexOf(className);
				if (nameIndex === -1) {
					classString += '' + className;
				} else {
					classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
				}
				element.className = classString;
			},
			// 下拉菜单事件处理
			handleCommand(command) {
				let handle = {
					// 登出
					c: () => {
						this.$baseConfirm(this.langTxt('是否退出'), this.langTxt('提示'), async () => {
							this.$store.commit('setUser', '');
							sessionStorage.removeItem('admin-info'), this.$store.commit('setToken', '');
							sessionStorage.removeItem('admin-token'), this.$router.push('/login');
						});
					}
				};
				handle[command] && handle[command]();
			},
			// 锁屏
			lock() {
				this.$prompt('', this.langTxt('锁屏'), {
					confirmButtonText: this.langTxt('确认'),
					cancelButtonText: this.langTxt('取消'),
					inputPlaceholder: this.langTxt('请输入锁屏密码'),
					inputPattern: /^[A-Za-z0-9!@#$%^&*?]+$/,
					inputErrorMessage: this.langTxt('只能输入英文，数字，特殊字符的组合')
				})
					.then(({ value }) => {
						this.$store.commit('updateLock', value);
					})
					.catch(() => {});
			}
		},
		watch: {
			value() {
				this.toggleClass(document.body, 'custom-theme');
			}
		}
	};
</script>

<style scoped lang="scss">
	.header {
		width: 100%;
		height: 60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: $header-link-color;
		background-color: $header-bg;
	}

	.header > div {
		display: flex;
		align-items: center;
	}

	.link {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 20px;
		line-height: 60px;
		font-size: 24px;
		cursor: pointer;
	}

	.link:hover {
		background: $header-link-hover;
	}

	.dropdown {
		font-size: 14px;
		color: $header-link-color;
	}
</style>
